import { GetUserZodSchema } from "@redotech/account-common/user";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/**
 * This doesn't represent the status of the metadata but rather the status of this timeline pending timeline message.
 */
export enum PendingLockStatus {
  PENDING = "pending",
  COMPLETE = "complete",
  DELETED = "deleted",
}

const TimelineEventSchema_ = z.object({
  customer: z
    .object({
      firstName: z.string().nullish(),
      lastName: z.string().nullish(),
      email: z.string().nullish(),
      gravatarUrl: z.string().nullish(),
    })
    .nullish(),
  user: z.union([GetUserZodSchema, zExt.objectId()]).nullish(),
  image: z.string().nullish(),
  imageUrls: z.array(z.string()).nullish(),
  isShipment: z.boolean(),
  _id: zExt.objectId(),
  message: z.string().nullish(),
  link: z
    .object({
      message: z.string().nullish(),
      orderNumber: z.string().nullish(),
      url: z.string().nullish(),
    })
    .nullish(),
  subMessage: z.string().nullish(),
  isSystem: z.boolean().nullish(),
  updatedAt: z.date(),
  createdAt: z.date().nullish(),
  pendingLock: z
    .object({
      metadataKey: z.string(),
      retryButtonTitle: z.string().nullish(),
      completeButtonTitle: z.string().nullish(),
      response: z
        .object({ responder: zExt.objectId(), submittedAt: z.date() })
        .nullish(),
      status: createEnum(PendingLockStatus, { enumName: "PendingLockStatus" }),
    })
    .nullish(),
});
export const TimelineEventSchema: z.ZodType<TimelineEvent> =
  TimelineEventSchema_;
export type TimelineEvent = z.infer<typeof TimelineEventSchema_>;
